module.exports = __webpack_public_path__ + "fonts/Graphik-SemiboldItalic.37c42161.ttf";